import { LoadingStatuses } from 'core/common/entities';
import { FeatureFlagsConfig } from '../entities';

// ts-prune-ignore-next-line
export type FeatureFlagsState = {
  config: NonNullable<FeatureFlagsConfig['features']> | null;
  loadingStatus: LoadingStatuses;
  features: Record<string, string>;
  experiments: Record<string, string>;
};

export const featureFlagsInitialState: FeatureFlagsState = {
  config: null,
  features: {},
  experiments: {},
  loadingStatus: LoadingStatuses.IDLE,
};
